import { gql } from '@apollo/client';

export const createPromptMutation = gql`
  mutation createPrompt(
    $title: String!
    $description: String!
    $territoryId: ID!
    $startDate: DateTime
    $endDate: DateTime
    $coverImage: Upload
  ) {
    createPrompt(
      title: $title
      description: $description
      territoryId: $territoryId
      startDate: $startDate
      endDate: $endDate
      coverImage: $coverImage
    ) {
      article {
        id
        coverImage {
          id
          publicUrl
          publicUrlTransformed
          _meta {
            public_id
            height
            width
          }
        }
      }
    }
  }
`;
